var finansudd = finansudd || {};

finansudd.search = new function() {

	var self = this;

	// Do stuff when the input if focus - ex Open Auto suggest overlay
	this.focusEvent = function () {
		var selector = $('.search-input');

		selector.focus(function(){
			$('body').addClass('open-overlay searchform-open');
		});

		selector.blur(function(){

/*			// Add delay
			setTimeout(function() {
				removeOverlay();
			}, 1000);*/

		});

		finansudd.overlay.removeActive('body', 'searchform-open');

	};

	this.preventSearch = function () {
		var $submitButton = $('.search-form button[type="submit"]');

		$submitButton.click(function(e) {

			if(!$('body').hasClass('searchform-open')) {
				e.preventDefault();
				$('.search-input').focus();
			}

		});
	};

}